import { useEffect } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getFormalOfferByLoanOfferId } from '@helpers/FormalOffers/getFormalOfferByLoanOfferId';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Card } from '@iwoca/orion';

import { ApprovalHeader } from '../ApprovalHeader';
import { ChooseAmount } from '../ChooseAmount';
import { TOfferSetType } from '../getOfferSetType';
import { NewLoanSummary } from '../NewLoanSummary/NewLoanSummary';
import { OfferTimeoutAlertBox } from '../OfferTimeoutAlertBox';
import { PageContainer } from '../PageContainer';

const getSingleFormalOfferOrPartiallyDrawnDownFormalOffer = (
    offers: TFormalOffer[],
    loanOfferId: string
) => {
    if (offers.length === 1) {
        return offers[0];
    }

    return getFormalOfferByLoanOfferId(offers, loanOfferId);
};

export const MoreFundsOnly = ({
    formalOffers,
    timeoutDate,
    offerSetType,
    selectedAmount,
    setSelectedAmount,
    outstandingBalance,
    loanOfferId
}: {
    formalOffers: TFormalOffer[];
    timeoutDate: string;
    offerSetType: TOfferSetType;
    selectedAmount: number;
    setSelectedAmount: (amount: number) => void;
    outstandingBalance: number;
    loanOfferId: string;
}) => {
    const moreFundsOnlyOffer =
        getSingleFormalOfferOrPartiallyDrawnDownFormalOffer(
            formalOffers,
            loanOfferId
        );
    const maxAvailableCash = moreFundsOnlyOffer.available_cash;

    // If the loan offer id matches the id on the more funds only offer, it has been drawn down on previously
    const isPartialDrawdown = Boolean(
        getFormalOfferByLoanOfferId([moreFundsOnlyOffer], loanOfferId)
    );

    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: 'more_funds_only'
        });
    }, []);

    return (
        <PageContainer data-testid="more-funds-only">
            <Card className="space-y-xl min-l:p-xl">
                <OfferTimeoutAlertBox timeoutDate={timeoutDate} />
                <ApprovalHeader offerSetType={offerSetType} />
                <ChooseAmount
                    selectedAmount={selectedAmount}
                    setSelectedAmount={setSelectedAmount}
                    maxAmount={maxAvailableCash!}
                />
            </Card>
            <NewLoanSummary
                selectedAmount={selectedAmount}
                selectedOffer={moreFundsOnlyOffer}
                outstandingBalance={outstandingBalance}
                isPartialDrawdown={isPartialDrawdown}
            />
        </PageContainer>
    );
};
